module.exports = __webpack_public_path__ + "static/media/lock.22b027c8.svg";